import {
    defined,
    DeveloperError,
    Color,
    Primitive,
    GeometryInstance,
    PolylineGeometry,
    Cartesian3,
} from 'cesium';
import { PolylineMaterialAppearance, Material } from 'cesium';

class ODLineLayer {
    constructor(viewer, linData) {
        if (!defined(viewer)) {
            throw new DeveloperError('viewer is required');
        }
        this.viewer = viewer;
        this.primitive = null;
        this.loadLinesData(this.viewer, linData);
    }

    loadLinesData(viewer, linData) {
        const busLines = [];
        // linData.forEach(i => {
        //
        //   let points = []
        //   i.forEach(c => {
        //     points.push(c[0], c[1])
        //   });
        //   // points.push(points[0], points[1])
        //
        //   busLines.push({
        //     positions: linData,
        //     color: new Color(0.5, 0.6, 0.0, 1.0),
        //   });
        // })

        busLines.push({
            positions: linData,
            color: new Color(0.5, 0.6, 0.0, 1.0),
        });

        this.addLineDatas(busLines, viewer);
    }

    addLineDatas(busLines, viewer) {
        let scene = viewer.scene;
        busLines.forEach(line => {
            this.primitive = new Primitive({
                geometryInstances: new GeometryInstance({
                    geometry: new PolylineGeometry({
                        positions: Cartesian3.fromDegreesArray(line.positions),
                        width: 5,
                    }),
                }),
                appearance: new PolylineMaterialAppearance({
                    material: new Material({
                        fabric: {
                            type: 'ODLineMaterial',
                            uniforms: {
                                color_0: line.color,
                                colorImage: Color.AQUA,
                                totoalFrameCount_1: 400,
                            },
                            source: `
                uniform float totoalFrameCount_1;
                uniform vec4 color_0;
                uniform vec4 colorImage;
                czm_material czm_getMaterial(czm_materialInput materialInput)
                {
                    czm_material material = czm_getDefaultMaterial(materialInput);
                    vec2 st = materialInput.st;
                    float t = mod(czm_frameNumber, totoalFrameCount_1) / totoalFrameCount_1;
                    t *= 1.03;
                    float alpha = smoothstep(t - 0.1, t, st.s) * step(-t, -st.s);
                    alpha += 0.1;
                    alpha *= step(-0.4, -abs(0.5-st.t));
                    // material.diffuse = color_0.rgb;
                    material.diffuse = (colorImage.rgb+color_0.rgb);
                    material.alpha = alpha;
                    return material;
                }
              `,
                        },
                        translucent: true,
                    }),
                    faceForward: false,
                    closed: false,
                }),
            });
            console.log(this.primitive, 'this.primitive');
            scene.primitives.add(this.primitive);
        });
    }

    destroy() {
        this.primitive && this.viewer.scene.primitives.remove(this.primitive);
    }
}

export default ODLineLayer;
